import { render, staticRenderFns } from "./AreaSelected.vue?vue&type=template&id=5346b139&scoped=true"
import script from "./AreaSelected.vue?vue&type=script&lang=js"
export * from "./AreaSelected.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5346b139",
  null
  
)

export default component.exports